import { API_BASE_URL } from '../common/ApiClient';
import { BusinessLogUrl } from './query/BusinessLogUrl';

export * from './schema';
export type * from './schema/types';
export * from './query/useBusinessLogQuery';

export const AlgorithmFileUrl = API_BASE_URL + BusinessLogUrl.ALGORITHM_FILE;
